import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { importGoogleLibrary } from '../../services/googleMaps';

export default function GoogleStreetView({ location, onAvailabilityChange }) {
  const hostRef = useRef(null);
  const [state, setState] = useState('loading');
  const lat = Number(location?.lat);
  const lng = Number(location?.lng);

  useEffect(() => {
    let active = true;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      setState('unavailable');
      onAvailabilityChange?.(false);
      return undefined;
    }
    importGoogleLibrary('streetView').then(({ StreetViewService, StreetViewPanorama, StreetViewStatus }) => {
      const service = new StreetViewService();
      service.getPanorama({ location:{ lat, lng }, radius: 80, preference: 'nearest' }, (data, status) => {
        if (!active) return;
        const available = status === StreetViewStatus.OK && data?.location?.latLng;
        setState(available ? 'ready' : 'unavailable');
        onAvailabilityChange?.(Boolean(available));
        if (!available || !hostRef.current) return;
        new StreetViewPanorama(hostRef.current, {
          position: data.location.latLng,
          pov: { heading: 0, pitch: 0 },
          zoom: 0,
          addressControl: false,
          fullscreenControl: true,
          motionTracking: false,
        });
      });
    }).catch(() => {
      if (active) {
        setState('unavailable');
        onAvailabilityChange?.(false);
      }
    });
    return () => { active = false; };
  }, [lat, lng, onAvailabilityChange]);

  if (state === 'unavailable') return null;
  return <Frame><Host ref={hostRef}/>{state === 'loading' && <Loading>Buscando cobertura de Street View…</Loading>}</Frame>;
}

const Frame=styled.div`position:relative;width:100%;height:100%;min-height:360px;overflow:hidden;background:#e8ebe6`;
const Host=styled.div`width:100%;height:100%;min-height:360px`;
const Loading=styled.div`position:absolute;inset:0;display:grid;place-items:center;color:#657679;background:#ebe8df;font-size:.86rem`;
